export default "__VITE_ASSET__e8ecdab0__"